import React from "react";
import "./css/LandingStyle.css";

const Hero = ({ onBookDemo, onWatchVideo }) => {
  return (
    <section className="hero-modern">
      {/* Background Blobs for depth */}
      <div className="bg-glow-1"></div>
      <div className="bg-glow-2"></div>

      <div className="hero-container">
        <div className="news-badge">
          <span className="dot"></span>
          <span className="badge-text">
            Med-Co: medical software and healthcare solutions{" "}
          </span>
          <i className="fa fa-chevron-right"></i>
        </div>

        <h1 className="hero-title">
          Modernize Your Clinic. <br />
          <span className="blue-gradient-text">Empower Your Care.</span>
        </h1>

        <p className="hero-description">
          The all-in-one clinic management platform. From smart scheduling to
          secure patient records, <strong>Med-CO</strong> simplifies your
          practice so you can focus on what matters most.
        </p>

        <div className="hero-cta-group">
          <button className="btn-primary-blue" onClick={onBookDemo}>
            Get Started Free <i className="fa fa-arrow-right"></i>
          </button>
          <button className="btn-secondary-outline" onClick={onWatchVideo}>
            <div className="play-icon-wrapper">
              <i className="fa fa-play"></i>
            </div>
            Watch Video
          </button>
        </div>

        <div className="trust-indicator">
          <p>Trusted by 50+ forward-thinking clinics</p>
          <div className="trust-logos">
            {/* Replace with actual small greyed-out logos */}
            <span>Dependable</span>
            <span>Secure</span>
            <span>Seamless</span>
            <span>Validated</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
